export default __webpack_public_path__ + "static/media/logOut.2d19cce7.svg";